export const Api = {
  LARAVEL_LOCAL_HOSTNAME: 'https://starter-kit.localhost:80',
  LARAVEL_PROD_HOSTNAME: '',
  SWAGGER_HOSTNAME: 'https://virtserver.swaggerhub.com/actual/lucie-api/1.0.0',
};
